export const useDateMask = () => (input: string): string => {
  if (!input) return '';

  const digits = input.replace(/\D/g, '');

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;

  let day = '';
  let month = '';
  let year = '';

  if (digits.length >= 2) {
    const d = parseInt(digits.slice(0, 2), 10);
    const validDay = Math.min(Math.max(d, 1), 31);
    day = validDay.toString().padStart(2, '0');
  } else {
    day = digits.slice(0, 2);
  }

  if (digits.length >= 4) {
    const m = parseInt(digits.slice(2, 4), 10);
    const validMonth = Math.min(Math.max(m, 1), 12);
    month = validMonth.toString().padStart(2, '0');
  } else if (digits.length > 2) {
    month = digits.slice(2, 4);
  }

  if (digits.length >= 8) {
    const y = parseInt(digits.slice(4, 8), 10);
    const validYear = Math.min(
      Math.max(y, minYear),
      currentYear,
    );
    year = validYear.toString();
  } else if (digits.length > 4) {
    year = digits.slice(4, 8);
  }

  let result = '';
  if (day) result += day;
  if (month) result += ` / ${month}`;
  if (year) result += ` / ${year}`;

  return result;
};
